import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';

@Pipe({ name: '' })
export abstract class AbstractPipe implements PipeTransform, OnDestroy {
  protected _destroyed$: Subject<void> = new Subject<void>();

  public abstract transform(value: unknown, ...args: unknown[]): unknown;

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
